// extracted by mini-css-extract-plugin
export default {"img":"image_img__h52a+"};